import { aiFeatures } from '../../../../../api/coreData'

const FEATURE_CODE = 'portfolio-research-agent'

export function useResearchAgentEnabled () {
  const { data, isLoading } = aiFeatures.useAiFeatureSummary(FEATURE_CODE, {
    staleTime: 5 * 60 * 1000
  })
  const enabled = Boolean(data?.enabled)
  return { enabled, isLoading }
}
